class ClickTracker {
  constructor() {
    this.storageKey = 'click_tracking_data';
    this.cookieMaxAge = 7776000; // 90 dagen
    this.init();
  }

  init() {
    this.captureClickIds();
  }

  captureClickIds() {
    const trackingParams = {
      'gclid': 'gclid',
      'gclsrc': 'gclsrc',
      'wbraid': 'wbraid',
      'gbraid': 'gbraid',
      'dclid': 'dclid',
      'fbclid': 'fbclid',
      'fbc': 'fbc',
      'utm_source': 'utm_source',
      'utm_medium': 'utm_medium',
      'utm_campaign': 'utm_campaign',
      'utm_id': 'utm_id',
      'utm_term': 'utm_term',
      'utm_content': 'utm_content'
    };

    const urlParams = new URLSearchParams(window.location.search);
    const clickData = this.getData();

    Object.entries(trackingParams).forEach(([param, key]) => {
      const value = urlParams.get(param);
      if (value) {
        clickData[key] = value;
      }
    });

    const parseGoogleStreamCookie = () => {
      const gaCookieName = document.cookie
        .split(';')
        .map(c => c.trim().split('=')[0])
        .find(name => name.startsWith('_ga_'));

      if (!gaCookieName) return null;

      const ga4Cookie = this.getCookie(gaCookieName);
      if (!ga4Cookie) return null;

      const mapping = {
        s: 'sessionId',
        o: 'sessionNumber',
        g: 'sessionEngaged',
        t: 'lastHitTimestamp',
        j: 'joinTimer',
        l: 'enhancedUserIdLoggedInState',
        h: 'enhancedUserId',
        d: 'joinId'
      };

      const [version, , data] = ga4Cookie.split('.');

      if (version === 'GS1') {
        const values = ga4Cookie.split('.').slice(2);
        const keys = ['s', 'o', 'g', 't', 'j', 'l', 'h', 'd'];
        return Object.fromEntries(
          keys.map((k, i) => [mapping[k], values[i] || ''])
        );
      }

      return Object.fromEntries(
        data.replace(/%24/g, '$').split('$')
          .map(s => [mapping[s[0]] || s[0], decodeURIComponent(s.slice(1))])
      );
    };

    const gaClientIdCookie = this.getCookie('_ga');
    if (gaClientIdCookie) {
      const parts = gaClientIdCookie.split('.');
      if (parts.length >= 4) {
        clickData['ga_client_id'] = parts[2] + '.' + parts[3];
      }
    }

    const gSession = parseGoogleStreamCookie();
    if (gSession) {
      if (!clickData['ga_client_id'] && gSession.enhancedUserId) {
        clickData['ga_client_id'] = gSession.enhancedUserId + '.' + gSession.lastHitTimestamp;
      }
      clickData['ga_session_id'] = gSession.sessionId;
      clickData['ga_session_number'] = gSession.sessionNumber;
    }

    if (Object.keys(clickData).length > 0) {
      clickData.captured_at = new Date().toISOString();

      // Opslaan in localStorage
      localStorage.setItem(this.storageKey, JSON.stringify(clickData));

      const cookieParams = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign'];
      cookieParams.forEach(key => {
        if (clickData[key]) {
          document.cookie = `tracking_${key}=${encodeURIComponent(clickData[key])};path=/;max-age=${this.cookieMaxAge};SameSite=Lax`;
        }
      });
    }
  }

  getData() {
    try {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : {};
    } catch (e) {
      return {};
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
}

window.clickTracker = new ClickTracker();